import type { DisplayLink } from './types'

export const PAIRING_QR_ERROR = 'Este QR no es de vinculación.'
const pairingPath = '/master'
const tokenParameter = 'link'
// Opaque URL-safe token, not a credential format or a client-side TTL check.
const isToken = (token: string) => /^[A-Za-z0-9_-]+$/.test(token)

export function buildPairingQr(publicUrl: string, token: string): string {
  const base = new URL(publicUrl)
  // App routes are root-based pathname routes, not subdirectory/hash routes.
  if (!['http:', 'https:'].includes(base.protocol) || base.pathname !== '/' || base.search || base.hash || base.username || base.password) {
    throw new Error('VITE_PUBLIC_URL debe ser un origen HTTP(S), sin ruta, query ni hash.')
  }
  if (!isToken(token)) throw new Error(PAIRING_QR_ERROR)
  const url = new URL(pairingPath, base)
  url.searchParams.set(tokenParameter, token)
  return url.href
}

export function parsePairingQr(value: string, publicUrl: string, currentOrigin = publicUrl): string {
  try {
    const url = new URL(value, currentOrigin)
    const origins = [new URL(publicUrl).origin, new URL(currentOrigin).origin]
    const tokens = url.searchParams.getAll(tokenParameter)
    if (!['http:', 'https:'].includes(url.protocol) || !origins.includes(url.origin) || url.username || url.password ||
        ![pairingPath, `${pairingPath}/`].includes(url.pathname) || tokens.length !== 1 || !isToken(tokens[0])) {
      throw new Error(PAIRING_QR_ERROR)
    }
    // URLSearchParams decodes once. Expiration/consumption belong to the backend.
    return tokens[0]
  } catch { throw new Error(PAIRING_QR_ERROR) }
}

export function hasUsablePairingToken(display: DisplayLink, now = Date.now()): boolean {
  return display.state === 'UNLINKED' && !display.consumed && isToken(display.linkToken) && display.tokenExpiresAt > now
}

export function pairingQrForDisplay(display: DisplayLink, publicUrl: string): string | null {
  return hasUsablePairingToken(display) ? buildPairingQr(publicUrl, display.linkToken) : null
}
